import { Auth, IdTokenResult, onAuthStateChanged, ParsedToken, User } from 'firebase/auth';
import { LoadingHook, useLoadingValue } from 'react-firebase-hooks/util';
import { useEffect } from 'react';

export type UserClaimsHook = LoadingHook<ParsedToken | null, Error>;

type AuthStateOptions = {
	onUserChanged?: (user: User | null) => Promise<void>;
};

export const useUserClaims = (auth: Auth, options?: AuthStateOptions): UserClaimsHook => {
	const { error, loading, setError, setValue, value } = useLoadingValue<
		ParsedToken | null,
		Error
	>(() => null);

	useEffect(() => {
		const listener = onAuthStateChanged(
			auth,
			async (user) => {
				if (options?.onUserChanged) {
					// onUserChanged function to process custom claims on any other trigger function
					try {
						await options.onUserChanged(user);
					} catch (e) {
						setError(e as Error);
					}
				}
				let tokenResult: IdTokenResult | undefined;
				try {
					tokenResult = await user?.getIdTokenResult();
				} catch (e) {
					setError(e as Error);
				}

				setValue(tokenResult?.claims);
			},
			setError
		);

		return () => {
			listener();
		};
	}, [auth, options, setError, setValue]);

	return [value, loading, error];
};